import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Flex,
  Text,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import { colors } from 'packages/common-frontend/colors';
import { LineChartWithFormatters } from 'packages/common-frontend/components/LineChartWithFormatters';
import {
  ChartTimePeriod,
  dateFormatter,
} from 'packages/portfolio/ui/shared/portfolioChartUtils';

export const DaysPastDueChart: React.FC<{
  historicalRecords: any[];
  selectedTimePeriod: ChartTimePeriod;
}> = ({ historicalRecords, selectedTimePeriod }) => {
  const [data, setData] = useState<
    {
      xAxisValue: any;
      [key: string]: any;
    }[]
  >([]);

  useEffect(() => {
    const graphData: {
      xAxisValue: any;
      [key: string]: any;
    }[] = [];
    historicalRecords.forEach((record) => {
      if (record['rif.normalizeddayspastdue'] !== undefined)
        graphData.push({
          xAxisValue: record.reportingdate,
          daysPastDue: record['rif.normalizeddayspastdue'],
        });
    });
    setData(graphData);
  }, [historicalRecords]);

  return (
    <>
      <Box
        backgroundColor={colors.background[50]}
        mt="40px"
        border="none"
        borderRadius="8px"
        padding="40px"
      >
        <Flex>
          <Text fontSize="2xl" fontWeight="semibold" mb="40px">
            Days Past Due
          </Text>
        </Flex>
        {data.length === 0 ? (
          <Alert status="warning" borderRadius="6px">
            <AlertIcon />
            <AlertDescription fontWeight="semibold">
              Data is not available for the selected date range. Select another
              date range.
            </AlertDescription>
          </Alert>
        ) : (
          <Box
            padding="40px 40px 0px"
            background="white"
            borderRadius="8px"
            border="none"
          >
            <LineChartWithFormatters
              data={data}
              yAxisLabel="Days"
              xAxisTickFormatterType="months"
              coloredLines
              hideNodes
              xAxisTickFormatter={(value: any) =>
                dateFormatter({ date: value, timePeriod: selectedTimePeriod })
              }
              tooltip={{
                tooltipType: 'days',
                tooltipLabelType: 'date',
              }}
            />
          </Box>
        )}
      </Box>
    </>
  );
};
